import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Textarea from 'styles/elements/textarea';
import { ShortTextarea } from 'styles/elements/textarea/shortTextarea';
import InputElement from 'styles/elements/input';
import { ColumnDiv } from 'styles/elements/div';
import media from 'styles/media';
import { MaxCharLabel } from './maxCharLabel';

export const CharacterCounter = ({ id, answerLength, maxLength }) => (
  <MaxCharLabel maxLengthExceeded={answerLength > maxLength} aria-live="polite" id={id || 'max-char-label'}>
    {maxLength >= answerLength ? `You have ${maxLength - answerLength} characters remaining` : `You have ${(maxLength - answerLength) * -1} characters too many`}
  </MaxCharLabel>
);

export const FlexibleTextField = ({ subQuestion, compoundAnswers, handleUpdateCompoundAnswer, isInvalid, isReadOnly }) => {
  const textAreaRef = useRef(null);
  const value = compoundAnswers[subQuestion.questionId]?.value || '';
  const adjustTextAreaHeight = () => {
    const textarea = textAreaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight - 40}px`;
    }
  };

  const handleTextChange = event => {
    const newValue = event.target.value;
    handleUpdateCompoundAnswer({
      [subQuestion.questionId]: {
        answerId: subQuestion.answers[0].answerId,
        value: newValue,
        questionTags: subQuestion.tags,
      },
    });
    adjustTextAreaHeight();
  };

  useEffect(() => {
    adjustTextAreaHeight();
  }, [value]);
  const answerLength = value.length;

  return (
    <TextField>
      <CharacterCounter answerLength={answerLength} maxLength={500} id="max-char-label" />
      <TextField.ShortTextarea
        ref={textAreaRef}
        aria-label={subQuestion.text}
        value={value}
        onChange={handleTextChange}
        isInvalid={isInvalid}
        readOnly={isReadOnly}
        role="textbox"
        style={{ overflow: 'hidden' }}
      />
    </TextField>
  );
};

const TextField = styled(ColumnDiv)``;

const Input = styled(InputElement)`
  ${media.IE9 ? 'width: 100%;' : ''};
`;

TextField.MaxCharLabel = MaxCharLabel;
TextField.Textarea = Textarea;
TextField.Input = Input;
TextField.ShortTextarea = ShortTextarea;

export default TextField;
